import { render, staticRenderFns } from "./CustomDivider.vue?vue&type=template&id=4a07ae23&scoped=true&"
import script from "./CustomDivider.vue?vue&type=script&lang=js&"
export * from "./CustomDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a07ae23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
